import { render, staticRenderFns } from "./ViewOrderCreationStart.vue?vue&type=template&id=6096dd09&scoped=true&"
import script from "./ViewOrderCreationStart.vue?vue&type=script&lang=ts&"
export * from "./ViewOrderCreationStart.vue?vue&type=script&lang=ts&"
import style0 from "./ViewOrderCreationStart.vue?vue&type=style&index=0&id=6096dd09&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6096dd09",
  null
  
)

export default component.exports